module.exports = __webpack_public_path__ + "static/media/4ODA10.2a795584.jpg";